import { render, staticRenderFns } from "./icon-arrow.vue?vue&type=template&id=e6d84aa0&scoped=true&"
import script from "./icon-arrow.vue?vue&type=script&lang=js&"
export * from "./icon-arrow.vue?vue&type=script&lang=js&"
import style0 from "./icon-arrow.vue?vue&type=style&index=0&id=e6d84aa0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6d84aa0",
  null
  
)

export default component.exports